import { UpperCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PendingChanges } from '@core/guards/pending-changes.guard';
import { RestApiService } from '@core/services/rest-api.service';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import {
  DvDynamicFormModule,
  DvFormUtils,
  DvSavePanelModule,
  DvSlideToggleElement,
  FormOf,
} from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';

import { FormEditPermissionsDirective } from '@shared/directives/form-edit-permissions.directive';
import { PipesModule } from '@shared/pipes/pipes.module';
import { map, Observable, take } from 'rxjs';

@Component({
  imports: [
    DvDynamicFormModule,
    PipesModule,
    DvSavePanelModule,
    TranslateModule,
    FormEditPermissionsDirective,
    UpperCasePipe,
  ],
  selector: 'app-visma-integration',
  templateUrl: './visma-integration.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./visma-integration.component.scss'],
})
export class VismaIntegrationComponent implements OnInit, PendingChanges {
  private api = inject(RestApiService);
  private permissionsService = inject(UserRolesAndPermissionsService);

  readonly userPermissions: typeof RolesAndPermissions = RolesAndPermissions;
  formGroup: FormGroup<FormOf<{ IsVismaExpenseConnected: boolean }>>;
  element: DvDynamicFormElement = new DvSlideToggleElement({
    colspan: 1,
    key: 'IsVismaExpenseConnected',
  });

  ngOnInit(): void {
    this.formGroup = DvFormUtils.createFormGroup([this.element], true);
    this.handleAccessRestrictions();
    this.api
      .getCustom<boolean>('customer/GetExternalApplicationState/VismaExpense')
      .subscribe(isConnected => {
        this.formGroup.controls.IsVismaExpenseConnected.setValue(isConnected, {
          emitEvent: false,
        });
      });
  }

  hasChanges = (): boolean => this.formGroup.dirty && this.formGroup.valid;
  pendingChangesSave = (): Observable<boolean> => this.performSave();

  onSave(): void {
    this.performSave().subscribe();
  }

  private performSave(): Observable<boolean> {
    this.formGroup.markAsPristine();
    return this.api
      .postCustom('customer/SaveExternalApplicationState', {
        Application: 'Visma',
        Enabled: this.formGroup.controls.IsVismaExpenseConnected.value,
      })
      .pipe(map(() => true));
  }

  private handleAccessRestrictions(): void {
    this.permissionsService
      .hasPermissions([RolesAndPermissions.IntegrationSettingsEdit])
      .pipe(take(1))
      .subscribe(hasPermissions => {
        if (!hasPermissions) {
          this.formGroup.disable();
        }
      });
  }
}
